/**
 * סכמות שדות מודרכות לעריכת שלוחות ימות — תוויות בעברית פשוטה
 */

export const EXTENSION_TYPES = [
  {
    id: 'menu',
    typeValue: 'menu',
    label: 'תפריט',
    description: 'תפריט הקשות — המאזין בוחר אפשרות במספרים',
  },
  {
    id: 'api',
    typeValue: 'api',
    label: 'API (קישור לשרת)',
    description: 'מעביר את השיחה לשרת שלכם (כמו שלוחות המערכת)',
  },
  {
    id: 'playfile',
    typeValue: 'playfile',
    label: 'השמעה',
    description: 'משמיע קבצי שמע מהתיקייה',
  },
  {
    id: 'turbo',
    typeValue: 'turbo',
    label: 'טורבו',
    description: 'שלוחת טורבו של ימות המשיח',
  },
  {
    id: 'record',
    typeValue: 'record',
    label: 'הקלטה',
    description: 'מקליט הודעה מהמאזין',
  },
  {
    id: 'examination_american',
    typeValue: 'examination_american',
    label: 'מבחן אמריקאי',
    description: 'מודול מבחן שאלות אמריקאיות של ימות',
  },
  {
    id: 'other',
    typeValue: '',
    label: 'אחר / מתקדם',
    description: 'סוג מותאם — עריכת שדות חופשית',
  },
];

const YES_NO = [
  { value: 'yes', label: 'כן' },
  { value: 'no', label: 'לא' },
];

/** שדות משותפים לכל הסוגים */
export const COMMON_FIELDS = [
  {
    key: 'title',
    label: 'כותרת (שם לתצוגה)',
    help: 'שם קצר שיופיע בממשק — לא חובה',
    input: 'text',
  },
  {
    key: 'enter_id',
    label: 'לבקש מספר אישי בכניסה?',
    help: 'אם כן — המאזין יקיש מספר אישי לפני המשך',
    input: 'select',
    options: YES_NO,
  },
];

const TYPE_FIELDS = {
  menu: [],
  api: [
    {
      key: 'api_link',
      label: 'כתובת השרת (קישור)',
      help: 'למשל https://your-host/api/yemot/77',
      input: 'text',
      dir: 'ltr',
      required: true,
    },
    {
      key: 'api_url_post',
      label: 'לשלוח בשיטת POST?',
      help: 'רוב מערכות השרת שלנו דורשות כן',
      input: 'select',
      options: YES_NO,
    },
    {
      key: 'api_end_goto',
      label: 'לאן לחזור בסיום?',
      help: 'נתיב שלוחה, למשל / או /2',
      input: 'text',
      dir: 'ltr',
    },
  ],
  playfile: [
    {
      key: 'play_ok_digit',
      label: 'מקש לאישור (אופציונלי)',
      help: 'השאירו ריק אם לא רלוונטי',
      input: 'text',
    },
  ],
  turbo: [
    {
      key: 'turbo_ext',
      label: 'מזהה טורבו (אם יש)',
      help: 'לפי הגדרות ימות — השאירו ריק אם לא בטוחים',
      input: 'text',
    },
  ],
  record: [
    {
      key: 'record_max_length',
      label: 'אורך הקלטה מקסימלי (שניות)',
      help: 'מספר בלבד',
      input: 'text',
    },
  ],
  examination_american: [
    {
      key: 'examination_american_random_or_by_number',
      label: 'סדר שאלות',
      help: 'לפי מספר או אקראי',
      input: 'select',
      options: [
        { value: 'by_number', label: 'לפי מספר' },
        { value: 'random', label: 'אקראי' },
      ],
    },
    {
      key: 'examination_american_score_add_amount',
      label: 'ניקוד לכל תשובה נכונה',
      help: 'למשל 10',
      input: 'text',
    },
    {
      key: 'examination_american_answer_client',
      label: 'לאשר תשובה עם המאזין?',
      input: 'select',
      options: YES_NO,
    },
    {
      key: 'examination_american_end_goto',
      label: 'לאן לעבור בסיום המבחן',
      help: 'נתיב שלוחה',
      input: 'text',
      dir: 'ltr',
    },
  ],
  other: [],
};

export function fieldsForTypeId(typeId) {
  const common = COMMON_FIELDS;
  const specific = TYPE_FIELDS[typeId] || [];
  return [...common, ...specific];
}

export function resolveTypeIdFromValue(typeValue) {
  const t = String(typeValue || '').toLowerCase();
  if (!t) return 'other';
  if (t === 'id_list' || t.includes('menu')) return 'menu';
  if (t.includes('api')) return 'api';
  if (t.includes('play') || t === 'file' || t.includes('last_play')) return 'playfile';
  if (t.includes('turbo')) return 'turbo';
  if (t.includes('record') || t.includes('voicemail')) return 'record';
  if (t.includes('examination_american') || t.includes('exam')) return 'examination_american';
  return 'other';
}

export function typeValueForId(typeId, customType) {
  if (typeId === 'other') return String(customType || '').trim();
  const found = EXTENSION_TYPES.find((x) => x.id === typeId);
  return found?.typeValue || '';
}

/** שורשים רגישים — תואם לשרת */
export const SENSITIVE_ROOTS = new Set([
  '2', '3', '5', '7', '8', '9', '77',
  'audio', 'drasha', 'lesson', 'drasha_resume', 'lesson_resume',
]);

export function isSensitivePath(path) {
  const p = String(path || '').replace(/^\/+/, '').replace(/\/+$/, '');
  if (!p) return true;
  const root = p.split('/')[0];
  return SENSITIVE_ROOTS.has(root);
}

export function displayPath(path) {
  const p = String(path || '').replace(/^\/+/, '').replace(/\/+$/, '');
  return p ? `/${p}` : '/';
}

/**
 * מחשב diff קריא בין לפני/אחרי
 */
export function diffFields(before = {}, after = {}) {
  const keys = new Set([...Object.keys(before || {}), ...Object.keys(after || {})]);
  const changes = [];
  for (const k of keys) {
    const b = before?.[k] ?? '';
    const a = after?.[k] ?? '';
    if (String(b) === String(a)) continue;
    if (b === '' || b == null) changes.push({ key: k, kind: 'add', after: a });
    else if (a === '' || a == null) changes.push({ key: k, kind: 'remove', before: b });
    else changes.push({ key: k, kind: 'change', before: b, after: a });
  }
  return changes;
}

export function wereFieldsRemoved(before = {}, after = {}) {
  return Object.keys(before || {}).some((k) => !(k in (after || {})));
}
